import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Analytics, { GTM } from './components/Analytics';
import '@/App.css';
import './mobile-optimizations.css';
import '@/pages/ServiceDetail.css';
import Home from '@/Home';
import Mariages from '@/pages/Mariages';
import Communes from '@/pages/Communes';
import Evenementiel from '@/pages/Evenementiel';
import SpectaclesTransportables from '@/pages/SpectaclesTransportables';
import Blog from '@/pages/Blog';
import LaisserAvis from '@/pages/LaisserAvis';
import ModerationResult from '@/pages/ModerationResult';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Analytics />
        <GTM />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mariages" element={<Mariages />} />
          <Route path="/communes" element={<Communes />} />
          <Route path="/evenementiel" element={<Evenementiel />} />
          <Route path="/spectacles-transportables" element={<SpectaclesTransportables />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/laisser-avis" element={<LaisserAvis />} />
          <Route path="/moderation/:token" element={<ModerationResult />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
